import React, { Component } from "react";
import Modal from "react-modal";

import "./AddObjectButton.css";
import { Spinner } from "../../../Component/Spinner";
interface MyProps {
    createObject: Function;
    setModalOpen: Function;
    // modalIsOpen: boolean;
    // closeModal: Function;
}

class AddObjectModalContents extends Component<MyProps, any> {
    titleRef: React.RefObject<HTMLInputElement>;
    definitionRef: React.RefObject<HTMLInputElement>;

    constructor(props: any) {
        super(props);

        this.state = {
            loadingSubjects: false,
            subtitle: "subtitle",
            submitSpinner: false
        };

        this.titleRef = React.createRef();
        this.definitionRef = React.createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(ev: any) {
        ev.preventDefault();
        const component = this;

        this.setState({
            submitSpinner: true
        });

        const title = this.titleRef.current!.value;

        this.props.createObject(title, () => {
            component.setState({
                submitSpinner: false
            });
            component.props.setModalOpen(false);
        });
    }

    render() {
        return (
            <div>
                <div className="col-10">
                    <h2>Create New Card</h2>
                    <br />
                    <b>A card is a "thing" or concept from your studies. </b>
                    <br />
                    <br />
                    Examples:
                    <br />
                    <br />
                    <ul className="bulleted-list">
                        <li>
                            In Chemistry, a card could be an element from the
                            periodic table.
                        </li>
                        <li>It could be a person, place or thing.</li>
                        <li>It could be a theory. </li>
                        <li>In Geography it might be a state</li>
                        <li>In Anatomy a muscle or muscle group.</li>
                    </ul>
                </div>
                <br />
                <br />

                <form id="new-object-form" onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <div className="col-12">
                            <label>Name of Card:</label>
                            <input
                                className="form-control"
                                // innerRef={this.titleRef}
                                // field="title"
                                id="title"
                                type="text"
                                placeholder="A title for this object."
                            />
                        </div>
                    </div>
                    <br />
                    <br />
                    <div className="col-12">
                        <button
                            className="btn btn-outline-success pull-right"
                            type="submit"
                            id="submit"
                        >
                            Submit
                        </button>
                        <Spinner show={this.state.submitSpinner} />
                    </div>
                </form>
            </div>
        );
    }
}

export { AddObjectModalContents };
